// Modules
import moment from "moment";

import type { RangePickerProps } from "antd/es/date-picker";

export function useDateTimePicker() {
	const disabledDate: RangePickerProps["disabledDate"] = (current) => {
		// Cannot select days after today
		return current && current > moment().endOf("day");
	};

	return { disabledDate };
}
